import { render } from "./ClientConfirmModal.vue?vue&type=template&id=206a4d43&scoped=true"
import script from "./ClientConfirmModal.vue?vue&type=script&lang=js"
export * from "./ClientConfirmModal.vue?vue&type=script&lang=js"

import "./ClientConfirmModal.vue?vue&type=style&index=0&id=206a4d43&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206a4d43"]])

export default __exports__